'use client'

import { Media } from '@/payload-types'
import React from 'react'

export const avatarColors = [
  'bg-punch',
  'bg-powder',
  'bg-zest',
  'bg-slime',
  'bg-highlighter',
] as const

export const AuthorAvatar: React.FC<{
  author: { id: string; name: string; avatar: Media }
  size?: 24 | 20 | 16
}> = ({ author, size = 20 }) => {
  const randomColor = avatarColors[Math.floor(Math.random() * avatarColors.length)]
  const sizeClass =
    size === 24 ? 'w-[24px] h-[24px]' : size === 20 ? 'w-[20px] h-[20px]' : 'w-[16px] h-[16px]'
  return (
    <div className="flex">
      <div suppressHydrationWarning className={`${sizeClass} ${randomColor}`} />
      {author?.avatar && typeof author.avatar === 'object' ? (
        <img
          src={author.avatar.thumbnailURL || author.avatar.url || ''}
          alt={author.avatar.alt || 'author profile image'}
          className={`${sizeClass}`}
        />
      ) : (
        <div className={`${sizeClass} bg-slime`} />
      )}
    </div>
  )
}
